export const ORDERS_PATH = '/orders'

export function orderPath(orderId: string): string {
  return `${ORDERS_PATH}/${orderId}`
}
